import React, { useEffect, useState } from 'react';
import View from './View';
import InterventionOrder, { PostInterventionOrderBody } from 'src/interfaces/api/InterventionOrder';
import useInterventionOrder from 'src/hooks/api/useInterventionOrder';

const ViewContainer = ({ match, history }) => {
  const [interventionOrder, setInterventionOrder] = useState<InterventionOrder>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const { get, create, update } = useInterventionOrder();

  const { id } = match.params;

  useEffect(() => {
    if (id) {
      setError(undefined);
      setLoading(true);
      get(id)
        .then((request) => {
          setLoading(false);
          setInterventionOrder(request);
        })
        .catch((error) => {
          setLoading(false);
          setError(error.message);
        });
    }
  }, [id]);

  const handleSaveInterventionOrder = async (io: PostInterventionOrderBody): Promise<InterventionOrder> => {
    if (interventionOrder?.id) {
      return await update(interventionOrder?.id, io);
    } else {
      return await create(io);
    }
  };

  const handleGoBack = () => {
    history.push('/dashboard/intervention-orders');
  };

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <View
      goBack={handleGoBack}
      onSaveInterventionOrder={handleSaveInterventionOrder}
      interventionOrder={interventionOrder}
    />
  );
};

export default ViewContainer;
